<template>
  <section>
    <div
      class="tw:lg:max-w-(--tw-breakpoint-landing) tw:md:max-w-[638px] tw:sm:max-w-[480px] tw:max-w-[300px] tw:py-6 tw:lg:px-0 tw:mx-auto tw:lg:py-8 tw:flex tw:w-full tw:flex-col"
    >
      <div class="tw:flex tw:flex-col">
        <h2 class="tw:font-bold tw:lg:text-2xl tw:mb-8 tw:text-center tw:lg:text-left">
          {{ $t('tbs_mp_faq_header') }}
        </h2>
        <FaqLinksList :items="faq" />
      </div>
    </div>
  </section>
</template>
<script setup>
import { computed } from 'vue'
import FaqLinksList from '@/components/productPage/FaqLinksList.vue'

const props = defineProps({
  pageName: String,
})

const faq = computed(() => {
  if (props.pageName === 'rate-connect') {
    return [
      {
        key: 'rc_mp_faq_1',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=How-to-start-a-Rate-Connect-campaign',
      },
      {
        key: 'rc_mp_faq_2',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Expected-traffic-volume-with-a-Rate-Connect-campaign',
      },
      {
        key: 'rc_mp_faq_3',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Time-required-for-website-rates-to-go-live-with-Rate-Connect',
      },
      {
        key: 'rc_mp_faq_4',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=How-Rate-Connect-s-pay-per-stay-campaign-works',
      },
      {
        key: 'rc_mp_faq_5',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Markets-where-your-website-rates-are-promoted',
      },
      {
        key: 'rc_mp_faq_6',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Accepted-payment-methods-for-premium-products',
      },
    ]
  } else if (props.pageName === 'studio-plus') {
    return [
      {
        key: 'studio_plus_mp_faq_1',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Business-Studio-explained',
      },
      {
        key: 'studio_plus_mp_faq_2',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=How-Business-Studio-increases-your-property-s-accessibility-on-trivago',
      },
      {
        key: 'studio_plus_mp_faq_3',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=How-to-cancel-a-subscription',
      },
      {
        key: 'studio_plus_mp_faq_4',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=How-to-start-a-Business-Studio-subscription',
      },
      {
        key: 'studio_plus_mp_faq_5',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Rate-Insights-explained',
      },
      {
        key: 'studio_plus_mp_faq_6',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Accepted-payment-methods-for-premium-products',
      },
    ]
  } else if (props.pageName === 'landing') {
    return [
      {
        key: 'tbs_mp_faq_1',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Why-your-property-is-listed-on-trivago',
      },
      {
        key: 'tbs_mp_faq_2',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=How-to-register-your-property-on-trivago-Business-Studio',
      },
      {
        key: 'tbs_mp_faq_3',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Connectivity-providers-that-work-with-trivago',
      },
      {
        key: 'tbs_mp_faq_4',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Rates-on-trivago-explained',
      },
      {
        key: 'tbs_mp_faq_5',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=How-properties-get-listed-on-trivago',
      },
      {
        key: 'tbs_mp_faq_6',
        url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=How-to-reset-your-password',
      },
    ]
  } else return []
})
</script>
